import { Telegrams } from './Telegrams/Telegrams';
import { AirportDocuments } from './AirportDocuments/AirportDocuments';
import { Limitations } from './Limitations/Limitations';

export const ContentType = {
    TELEGRAMS: 0,
    LIMITATIONS: 1,
    DOCUMENTS: 2,
};

export const ContentTypes = {
    [ContentType.TELEGRAMS]: {
        title: 'labels.telegrams',
        component: Telegrams,
    },
    [ContentType.LIMITATIONS]: {
        title: 'labels.acLimitations',
        component: Limitations,
    },
    [ContentType.DOCUMENTS]: {
        title: 'labels.airportDocuments',
        component: AirportDocuments,
    },
};
